import React from "react"
import { connect } from "react-redux"
import propTypes from "prop-types"
import { Redirect, Link } from "react-router-dom"

import { signIn } from "../../../../services/authentication"
import configs from "../../../../configs"

import Form, {
  Group,
  Input,
  Password,
  Checkbox,
  GeneralErrorMessage
} from "../../../../components/Form"
import Nav from "../../../../components/Nav"
import Logo from "../../../../components/Logo"
import Button from "../../../../components/Button"

class SignIn extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      user: {
        email: {
          label: "Email",
          name: "email",
          type: "email",
          value: "",
          required: true,
          class: ""
        },
        password: {
          label: "Password",
          name: "password",
          type: "password",
          value: "",
          required: true,
          class: ""
        },
        keepMeSignIn: {
          label: "Keep me signed in",
          name: "keepMeSignIn",
          type: "checkbox",
          checked: false,
          value: "",
          required: false,
          class: ""
        }
      },
      generalErrorMessage: "",
      isSubmitted: false
    }
  }

  onChange = (name, field, value) => {
    const { user } = this.state

    this.setState({
      user: {
        ...user,
        [name]: {
          ...user[name],
          message: "",
          [field]: value
        }
      },
      generalErrorMessage: ""
    })
  }

  onSubmit = e => {
    e.preventDefault()

    const { user } = this.state
    const { onSignIn } = this.props

    this.setState({
      generalErrorMessage: ""
    })

    onSignIn(user).catch(fields => {
      this.setState({
        isSubmitted: true,
        generalErrorMessage: fields.generalErrorMessage,
        user: {
          ...user,
          ...fields
        }
      })
    })
  }

  render() {
    const { store, location } = this.props
    const { user, generalErrorMessage, isSubmitted } = this.state

    if (store.isLogged) {
      if (!store.user.primary_disability) {
        return <Redirect to="/general-information" />
      }
      return <Redirect to={location.state ? location.state.from : "/"} />
    }

    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-7 authentication_sidebar">
            <Logo color="white" href="/" title="Resanec" />
            <Logo color="black" href="/" title="Resanec" mobile />

            <div className="authentication_sidebar_container">
              <h1 className="authentication_sidebar_title">
                NDIS Pre-Planning
              </h1>
              <div className="authentication_sidebar_subtitle">
                Online is easy. When done together, it’s better.
              </div>
              <div className="authentication_sidebar_description">
                <ul>
                  <li>Easy collaboration with family, friends</li>
                  <li>Efficient editing and revising capability</li>
                  <li>
                    Dynamic commenting facility to provide input and feedback on
                    pre-plan progress and is
                  </li>
                  <li>ideal if you live in a remote location....and more.</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="col-lg-5 authentication_content authentication_content--dark">
            <Nav
              navigation={configs.authentication.navigation}
              className="nav--right nav--dark"
            />

            <div className="authentication_content_container">
              <h2 className="authentication_content_title">Sign In</h2>

              <Form onSubmit={this.onSubmit}>
                <Group>
                  <Input
                    onChange={this.onChange}
                    isSubmitted={isSubmitted}
                    field={user.email}
                  />
                </Group>

                <Group>
                  <Password
                    onChange={this.onChange}
                    isSubmitted={isSubmitted}
                    field={user.password}
                  >
                    <Checkbox
                      onChange={this.onChange}
                      isSubmitted={isSubmitted}
                      field={user.keepMeSignIn}
                    />
                  </Password>
                </Group>

                {generalErrorMessage && (
                  <GeneralErrorMessage message={generalErrorMessage} />
                )}

                <Group className="form_group--padding-top-lg text-right">
                  <Button
                    button={{ type: "submit", disabled: store.loading }}
                    className="btn--secondary btn--width-full btn--height-md"
                  >
                    Sign In
                  </Button>
                  <Link className="form_link" to="/forgot-password">
                    Forgot password?
                  </Link>
                </Group>

                <div className="form_create-account-link">
                  Don’t have an account
                  <br />
                  <Link to="/sign-up">Create an account now</Link>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

SignIn.propTypes = {
  onSignIn: propTypes.func,
  store: propTypes.shape({
    user: propTypes.shape({
      ndis_number: propTypes.string,
      primary_disability: propTypes.string
    }),
    isLogged: propTypes.bool,
    loading: propTypes.bool
  }).isRequired,
  location: propTypes.shape({
    state: propTypes.shape({
      from: propTypes.object
    })
  }).isRequired
}

SignIn.defaultProps = {
  onSignIn: () => {}
}

const mapStateToProps = ({ AuthenticationReducer }) => ({
  store: AuthenticationReducer
})

const mapDispatchToProps = dispatch => ({
  onSignIn: (user, error) => dispatch(signIn(user, error))
})

export default connect(mapStateToProps, mapDispatchToProps)(SignIn)
